import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {Configuration, UserRequest} from '../models';
import {AppConfig} from '@app/shared/services/app.config';

export class AuthorizationDialogType {
  showStatus: boolean;
  textField: string;
}

@Injectable()
export class LandingService {
  private isSignupShowed = false;
  private isAuthorizationShowed = false;
  private signupDialogSubj = new BehaviorSubject(false);
  private isLoginShowed = false;
  private browserCheck = false;
  private loginDialogSubj = new BehaviorSubject(false);
  private authorizationDialogSubj = new BehaviorSubject<AuthorizationDialogType>({showStatus: false, textField: ''});
  private browserCheckDialogSubj = new BehaviorSubject(false);
  private emailSendDialog = false;
  private emailSendDialogubj = new BehaviorSubject(false);
  private currentUser = new UserRequest();
  private userSubj = new BehaviorSubject(null);
  private loginSubj = new BehaviorSubject<UserRequest>(null);
  private Config: Configuration;

  constructor() {
    this.Config = AppConfig.config;
  }

  getSignupDialogSub() {
    return this.signupDialogSubj.asObservable();
  }

  getLoginDialogSub() {
    return this.loginDialogSubj.asObservable();
  }

  getAuthorizationDialogSub() {
    return this.authorizationDialogSubj.asObservable();
  }

  getEmailSendDialogSub() {
    return this.emailSendDialogubj.asObservable();
  }

  getCurrentUser() {
    return this.userSubj.asObservable();
  }

  getLoginSub() {
    return this.loginSubj.asObservable();
  }
  getBrowserCheckDialog() {
    return this.browserCheckDialogSubj.asObservable();
  }

  toggleSignupDialog(flag?: boolean) {
    if (flag !== undefined) {
      this.isSignupShowed = flag;
    } else {
      this.isSignupShowed = !this.isSignupShowed;
    }
    this.signupDialogSubj.next(this.isSignupShowed);
  }

  toggleLoginDialog(flag?: boolean) {
    if (flag !== undefined) {
      this.isLoginShowed = flag;
    } else {
      this.isLoginShowed = !this.isLoginShowed;
    }
    this.loginDialogSubj.next(this.isLoginShowed);
  }

  toggleAuthorizationDialog(flag?: boolean, textState?: boolean) {
    if (flag !== undefined) {
      this.isAuthorizationShowed = flag;
    } else {
      this.isAuthorizationShowed = !this.isAuthorizationShowed;
    }
    const thisTextState = (textState) ? this.Config.AuthorizationShowTextTimeout : this.Config.AuthorizationShowTextClicked;
    this.authorizationDialogSubj.next({showStatus: this.isAuthorizationShowed, textField: thisTextState});
  }

  toggleBrowserWarning(flag?: boolean) {

    if (flag !== undefined) {
      this.browserCheck = flag;
    } else {
      this.browserCheck = !this.browserCheck;
    }
    this.browserCheckDialogSubj.next(this.browserCheck);
  }

  toggleEmailSendDialog(flag?: boolean) {
    if (flag !== undefined) {
      this.emailSendDialog = flag;
    } else {
      this.emailSendDialog = !this.emailSendDialog;
    }
    this.emailSendDialogubj.next(this.emailSendDialog);
  }


  changeUser(user: UserRequest) {
    this.currentUser = user;
    this.userSubj.next(user);
  }

  callLogin(user: UserRequest) {
    this.changeUser(user);
    this.loginSubj.next(this.currentUser);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/landing.service.ts